import type { Alias } from '@ps/web-core-store';

// eslint-disable-next-line stars-web/no-restricted-alias-import
import { sportsRoutes } from '@swf/sports/routes';

type Routes = Partial<Record<Alias, string>>;

export const aliases: Routes = {
  home: '/',
  casinoGameInfo: '/game/:name/:gtype/:vtype',
  firstWalletHome: '/cashier/',
  homeGamesLandingPage: '/homegames/',
  homeGamesClubs: '/homegames/clubs/:clubId?/:section?/:subsection?/',
  homeGamesCashGames: '/homegames/cash-games/',
  homeGamesTournaments: '/homegames/tournaments/',
  homeGamesInvite: '/homegames/invite/',
  homeGamesPromotion: '/homegames/promotion/:clubId?/:clubName?/',
  helpCenterArticle: '/help/articles/:ref/:id?/',
  helpCenter: '/help/:page?/',
  helpCenterCategoryArticles: '/help/categories/:category/',
  helpCenterSearchArticles: '/help/search/:searchTerm/:page?/',
  pokerPowerPath: '/poker/play-poker/power-path/:tab?/',
  pokerCashGames: '/poker/play-poker/cash-games/:view/:tab?/',
  ...sportsRoutes
};
